import type { FC } from "react";
import React from "react";

import type { Category } from "@apis/calorie-grid/models";

import { CATEGORY_META } from "../../../bootstrap/category.ts";

interface ShapePreviewProps {
  readonly category: Category;
  readonly squaresPerRow: number;
  readonly totalSquares: number;
}

export const ShapePreview: FC<ShapePreviewProps> = ({
  category,
  squaresPerRow,
  totalSquares,
}) => {
  const categoryColor = CATEGORY_META[category].color;

  const rowCount = Math.ceil(totalSquares / squaresPerRow);
  const rows = Array.from({ length: rowCount }, (_, row) => {
    const colCount =
      row === rowCount - 1
        ? totalSquares - squaresPerRow * (rowCount - 1)
        : squaresPerRow;

    // oxlint-disable-next-line @typescript-eslint/no-shadow
    return Array.from({ length: colCount }, (_, col) => col);
  });

  return (
    <div className="flex size-[50px] shrink-0 items-start justify-start overflow-hidden rounded-lg bg-muted p-[5px]">
      <div className="flex flex-col gap-0.5">
        {rows.map((cols, row) => (
          <div className="flex gap-0.5" key={row}>
            {cols.map(col => (
              <span
                className="size-2 rounded-[1px]"
                key={col}
                style={{ backgroundColor: categoryColor }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
